import React from 'react';
import Popup from 'reactjs-popup';
import TemplateCardImage from '../../../assets/icons/templateCard.svg';
import TripleDotsImage from '../../../assets/icons/tripleDots.svg';
import 'reactjs-popup/dist/index.css';

import './templateCard.scss';
import { useNavigate } from 'react-router-dom';
import HolidaySelectionModal from '../holidaySelectionModal/holidaySelectionModal';

interface IBadgeProps {
    type: string;
}

interface ITemplateCardProps {
    type: string;
    name: string;
    allowance: string;
    report: string;
    amount: number;
}

const Badge = ({ type }: IBadgeProps) => {
    if (type == 'hourly') {
        return <div className="payCard">시급</div>;
    } else if (type == 'weekly') {
        return <div className="payCard weekly">주급</div>;
    } else if (type == 'monthly') {
        return <div className="payCard monthly">월급</div>;
    }
    return <></>;
};

const TemplateCard = ({ type, name, allowance, report, amount }: ITemplateCardProps) => {
    const navigate = useNavigate();
    return (
        <div className="workingTemplateCard">
            <div className="headerRow">
                <div className="titleContainer">
                    <div className="image">
                        <img src={TemplateCardImage} alt="" />
                    </div>
                    <div className="text">{name}</div>
                </div>
                <div className="dropDown">
                    <Popup
                        trigger={<img src={TripleDotsImage} alt="" />}
                        position="right top"
                        className="templateCardPopupContent"
                    >
                        <div className="templateCardPopupContent">
                            <div
                                className="templateCardPopupContentMenuItem"
                                onClick={() => {
                                    navigate('/edit-working-template');
                                }}
                            >
                                수정
                            </div>
                            <div className="templateCardPopupContentMenuItem">
                                <HolidaySelectionModal
                                    title={'삭제'}
                                    header="추가완료"
                                    description={'근로템플릿이 추가되었습니다.'}
                                    buttonText={'확인'}
                                />
                            </div>
                        </div>
                    </Popup>
                </div>
            </div>

            <div className="dataContainer">
                <div className="salaryInfo">
                    <div className="header">급여정보</div>
                    <div className="data">
                        <Badge type={type} />
                        <div className="amount">{amount.toFixed(3)} 원</div>
                    </div>
                </div>
                <div className="allowance">
                    <div className="header">주휴수당</div>
                    <div className="data">
                        {allowance.slice(0, 32)}
                        {allowance.length > 32 ? '...' : ''}
                    </div>
                    {}
                </div>
                <div className="report">
                    <div className="header">소득신고</div>
                    <div className="data">{report}</div>
                </div>
            </div>
        </div>
    );
};

export default TemplateCard;
